import {
  CSSProperties,
  ReactNode,
  HTMLAttributes,
  cloneElement,
  isValidElement,
} from 'react';

type StandardUiOverlayPositions =
  | 'top-left'
  | 'top-right'
  | 'bottom-left'
  | 'bottom-right';

type UiOverlayPosition =
  | {
      top?: number | string;
      left?: number | string;
      right?: number | string;
      bottom?: number | string;
    }
  | StandardUiOverlayPositions;

export type UiOverlayProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
  component: ReactNode;
  position: UiOverlayPosition;
};

const translatePosition = (position: UiOverlayPosition) => {
  if (typeof position === 'object') return position;

  switch (position) {
    case 'top-left':
      return { top: '2rem', left: '2rem' };
    case 'top-right':
      return { top: '2rem', right: '2rem' };
    case 'bottom-left':
      return { bottom: '2rem', left: '2rem' };
    case 'bottom-right':
      return { bottom: '2rem', right: '2rem' };
  }
};

export const UiOverlay = ({
  children,
  component,
  position,
  ...props
}: UiOverlayProps) => {
  const overlayStyle = {
    position: 'absolute' as const,
    ...translatePosition(position),
  };

  const componentWithPosition = isValidElement<{ style?: CSSProperties }>(
    component,
  )
    ? cloneElement(component, {
        style: { ...component.props.style, ...overlayStyle },
      })
    : component;

  return (
    <div style={{ ...props.style, position: 'relative' }} {...props}>
      {children}
      {componentWithPosition}
    </div>
  );
};
